import React from "react";
import { philosophy } from "../mock";

export default function Philosophy() {
  return (
    <section id="strategy" className="py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-4xl mx-auto reveal">
          <p className="eyebrow">{philosophy.eyebrow}</p>
          <h2 className="mt-8 font-serif-display text-4xl sm:text-6xl font-semibold leading-[1.05] tracking-tight">
            Strategy eats sales
            <br className="hidden sm:block" />
            <span className="text-gradient-gold"> for breakfast.</span>
          </h2>

          <div className="mt-8 space-y-5 max-w-2xl mx-auto">
            {philosophy.body.map((p, i) => (
              <p key={i} className="text-lg font-light leading-relaxed text-[var(--ivory)]/75">
                {p}
              </p>
            ))}
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {philosophy.pillars.map((p, i) => (
            <div
              key={p.n}
              className="card-lux rounded-2xl p-8 reveal"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="font-serif-display text-sm tracking-[0.3em] text-[var(--gold)]">
                {p.n}
              </div>
              <div className="hairline my-5" />
              <h3 className="font-serif-display text-xl font-semibold">{p.title}</h3>
              <p className="mt-3 text-sm text-[var(--muted)] leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
